"use client";

import { GiftRecipientLandingView } from "./GiftRecipientLandingView";
import type { ClaimOfferPageData } from "./types";
import { useGiftRecipientLanding } from "./use-gift-recipient-landing";

/**
 * Client island: joins the page hook to the view. Everything per-visitor
 * happens here so the server template stays cacheable.
 */
export function GiftRecipientLanding({ page }: { page: ClaimOfferPageData }) {
	const landing = useGiftRecipientLanding();

	return <GiftRecipientLandingView page={page} {...landing} />;
}
